export default __webpack_public_path__ + "static/media/youtube.54b7fd9e.svg";